import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  fetchDailyGift,
  selectClaimDailyGiftDataState,
  selectDailyGift,
  selectDailyGiftDataState,
  selectDailyGiftStatus,
} from '../state/dailyGift.slice';

const useDailyGift = () => {
  const dispatch = useDispatch();
  const dailyGift = useSelector(selectDailyGift);
  const dailyGiftStatus = useSelector(selectDailyGiftStatus);
  const dailyGiftDataState = useSelector(selectDailyGiftDataState);
  const claimDailyGiftDataState = useSelector(selectClaimDailyGiftDataState);

  const returnObj = useMemo(
    () => ({
      dailyGift,
      dailyGiftStatus,
      dailyGiftDataState,
      claimDailyGiftDataState,
    }),
    [dailyGift, dailyGiftStatus, dailyGiftDataState, claimDailyGiftDataState],
  );

  useEffect(() => {
    if (dailyGiftDataState === 'idle') {
      dispatch(fetchDailyGift());
    }
  }, [dailyGiftDataState, dispatch]);

  return returnObj;
};

export default useDailyGift;
